// @file 商品信息Item公用mixin
import { tryParseJSON } from '@polyv/utils/src/lang';
import basicMixin from '../../assets/mixins/basic';
import { isMobile } from '@polyv/utils/src/browser';
import { ossCompress } from '@/assets/utils/utils';
import { ynToBool } from '@polyv/utils/src/boolean';

export default {
  mixins: [basicMixin],

  inject: ['productVm'],

  data() {
    return {
      labels: [],
      isMobile: isMobile(),
    };
  },

  props: {
    good: {
      type: Object,
      default: () => ({})
    },
    number: {
      type: Number,
      default: 1,
    },
    hotTimes: {
      type: Number,
      default: 0
    },
    lastHotTimes: {
      type: Number,
      default: 0
    },
    hotEffectEnabled: {
      type: Boolean,
    },
    isTop: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    good: {
      immediate: true,
      handler() {
        this.parseFeatures();
      },
    },
  },

  computed: {
    linkType() {
      return Number(this.good.linkType || 10);
    },

    params() {
      try {
        return JSON.parse(this.good.params);
      } catch (e) {
        return {};
      }
    },

    treatment() {
      return this.params.treatment;
    },

    isJobType() {
      return this.good.productType === 'position';
    },

    productExplainEnabled() {
      return this.productVm.getProductExplainEnabled();
    },

    redirectDirectlyEnabled() {
      return this.good.productType === 'normal' &&
        this.good.buyType === 'link' &&
        this.productVm.redirectDirectlyEnabled;
    },

    shouldHidePrice() {
      return !ynToBool(this.good.openPriceEnable || 'Y') && this.good.realPrice !== 0;
    },
    hidePriceQuestionMarks() {
      if (!this.good.realPrice) return '??';

      const priceStr = String(this.good.realPrice);
      const integerPart = priceStr.split('.')[0];

      // 最多显示 3 个问号
      const repeatCount = Math.min(integerPart.length, 3);

      return '?'.repeat(repeatCount);
    },
    isSoldOut() {
      if (this.good.productType === 'normal') {
        if (this.good.buyType === 'link') {
          return this.good.markAsSoldout === 'Y';
        }
        if (this.good.buyType === 'inner' && this.good.stockEnabled === 'Y') {
          return this.good.stock <= 0;
        }
      }
      return false;
    },
  },

  methods: {
    ossCompress,

    parseFeatures() {
      if (!this.good.features) { return; }
      this.labels = (tryParseJSON(this.good.features) || []).filter((text) => text);
    },

    oldPrice(good) {
      if (good.productType !== 'normal') {
        return;
      }

      if (good.originalPriceType === 'CUSTOM') {
        return good.customOriginalPrice;
      }

      return good.price ? `¥${good.price}` : '';
    },

    realPrice(price) {
      return price ? `￥${price}` : this.iarTrans('product.free');
    },

    clickDescEnter() {
      this.productVm.emitClickGoodDesc(this.good);
    },
    clickProduct() {
      this.$emit('click-product', this.good);
    },
    clickExplain() {
      this.$emit('click-explain', this.good);
    },
  },

  mounted() {
    this.parseFeatures();
  },
};
